import React, {useEffect, useRef, useState} from "react";
import {Toast}                              from "primereact/toast";
import {InputText}                          from "primereact/inputtext";
import {Button}                             from "primereact/button";
import {confirmDialog}                      from "primereact/confirmdialog";
import {Dialog}                             from "primereact/dialog";
import { Checkbox }                         from "primereact/checkbox";
import { MultiSelect }                      from 'primereact/multiselect';
import { ProgressSpinner }                  from 'primereact/progressspinner';

import api                from "../../services/api";
import {Obrigatorio}      from "../../styles/global";
import Tabela             from "../../components/tabela";
import {parametrosPadrao} from "../../configs/constantes";
import debug              from "../../utils/debug";
import {Calendar} from "primereact/calendar";


const Feriado = () => {
    const classe = 'Feriado';
    const tabela = 'feriados';
    const endpointAPI = 'cadastro/feriado';
    const aviso = useRef(null);
    const inicial = {id: 0, nome: '', idlojas: [], data: null, repetir_anualmente: 0};
    const [item, setItem] = useState(inicial);
    const [tituloTela, setTituloTela] = useState('');
    const [exibeTela, setExibirTela] = useState(false);
    const [listar, setListar] = useState(false);
    const [permissoesTela, setPermissoesTela] = useState(null);
    const [parametrosTela, setParametrosTela] = useState(parametrosPadrao);
    const [lojaLista, setLojaLista] = useState([]);
    const [loadingFormulario, setLoadingFormulario] = useState(true);

    useEffect((e) => {
        new api().requisitar('get', `configuracao/tela/feriado/permissoes`).then((resposta) => {
            setPermissoesTela(resposta);
            const parametros = {
                pesquisarTabela  : true,
                nomeClasse       : classe,
                tabela           : tabela,
                caminhoBreadcrumb: [{label: 'Cadastro'}, {label: 'Feriados'}],
                endpointApi      : endpointAPI,
                excluirRegistro  : true,
                tabelaDados      : {
                    reordenar              : false,
                    multiplaSelecao        : true,
                    apresentarDados        : resposta.listar ?? false,
                    botaoAdicionar         : resposta.cadastrar ?? false,
                    botaoExcluir           : resposta.excluir ?? false,
                    botaoEditarRegistro    : resposta.alterar ?? false,
                    botaoExcluirRegistro   : resposta.excluir ?? false,
                    botaoAuditoriaRegistro : resposta.auditoria ?? false,
                    botaoVisualizarRegistro: resposta.visualizar ?? false,
                    filtroStatus           : false,
                    colunas                : [
                        {legenda: 'Nome', campo: 'nome', ordenavel: true},
                        {legenda: 'Data', campo: 'data', ordenavel: true},
                        {legenda: 'Lojas', campo: 'lojas_nome', ordenavel: true},
                        {legenda: 'Repete Anualmente', campo: 'repetir_anualmente', ordenavel: true}
                    ]
                },
                abrirFormulario  : aoAbrirFormulario,
                finalizarPesquisa: aoListar
            }
            setParametrosTela(parametros);
        }).catch((erro) => {
            throw  {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
        });

        new api().requisitar('get', 'cadastro/loja/combo').then((resposta) => {
            setLojaLista(resposta);
        }).catch((erro) => {
            debug(erro);
        });

    }, []);

    const formatarData = (data) => {
        const [year, month, day] = data.split('-');
        return new Date(year, month - 1, day);
    };

    const aoAbrirFormulario = (registro) => {
        setItem(inicial);
        setLoadingFormulario(true);
        if (registro.id) {
            new api().requisitar('get', `${endpointAPI}/${registro.id}`).then((resposta) => {
                resposta.data = formatarData(resposta.data);
                resposta.idlojas = resposta.idlojas ? resposta.idlojas.map(item => item.idloja) : [];
                setItem(resposta);
                setLoadingFormulario(false);
            }).catch((erro) => {
                debug(erro);
            })
            setTituloTela(`Alterar ${classe}`);
        } else {
            setTituloTela(`Cadastro de ${classe}`);
            setLoadingFormulario(false);
        }
        setExibirTela(true);
    };

    const aoListar = () => setListar(false);

    const limparTela = () => {
        setItem(inicial);
        setExibirTela(false);
        setListar(true);
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            limparTela();
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({severity: 'error', summary: 'Erro', detail: (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado', life: 3000});
        });
    };

    const aoExcluirItem = (id) => {
        confirmDialog({
            message    : `Confirmar exclusão do ${classe}?`,
            header     : 'Atenção',
            icon       : 'pi pi-exclamation-triangle',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept     : () => {
                excluir(id);
            },
        });
    };

    const aoSalvar = async () => {
        try {
            if (!item.nome) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o nome!'};
            }
            if (!item.data) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe a data!'};
            }

            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), item).then((resposta) => {
                aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
                limparTela();
            }).catch((erro) => {
                throw  {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
            });

        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }
    };

    const aoDigitar = (e, propriedade) => {

        const texto = (e.target && e.target.value) || e.value || '';
        let _item = {...item};
        _item[`${propriedade}`] = texto;
        setItem(_item);

    };

    const aoSelecionar = (e, propriedade) => {
        let _item = {...item};
        if (e.checked) {
            _item[`${propriedade}`] = 1;
        }
        else {
            _item[`${propriedade}`] = 0;
        }
        setItem(_item);
    }

    const botoesAcaoTela = () => {
        return (<React.Fragment>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={(e) => setExibirTela(false)}/>
            {item.id > 0 && item.status > 0 && permissoesTela.exluir && <Button label="Excluir" icon="pi pi-times" className="p-button-text" onClick={(e) => aoExcluirItem(item.id)}/>}
            {((item.id > 0 && permissoesTela.alterar) || permissoesTela.cadastrar) && <Button label="Salvar" icon="pi pi-check" className="p-button-text" onClick={aoSalvar}/>}
        </React.Fragment>);
    };

    return (
        <Tabela parametros={parametrosTela} listar={listar}>
            <Toast ref={aviso}></Toast>
            <Dialog className='fluid' header={tituloTela} style={{maxWidth: '90%', width: '800px'}} footer={botoesAcaoTela} modal={true} visible={exibeTela} onHide={(e) => setExibirTela(false)}>
                {loadingFormulario ? (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '250px' }}>
                        <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                    </div>
                ) : (
                    <>
                        <div className="grid formgrid">
                            <div className="field col-12 mt-3">
                                <label htmlFor="titulo">Nome<Obrigatorio>*</Obrigatorio> </label><br/>
                                <InputText className="w-full" autoComplete="none" id="nome" maxLength={200} value={item.nome} onChange={(e) => aoDigitar(e, 'nome')} required/>
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12">
                                <label htmlFor="idpais">Data<Obrigatorio>*</Obrigatorio> </label><br/>
                                <Calendar
                                    id="date"
                                    value={item.data}
                                    onChange={(e) => aoDigitar(e, 'data')}
                                    className="w-full"
                                    dateFormat="dd/mm/yy"
                                />
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12">
                                <label htmlFor="idlojas">Loja</label><br/>
                                <MultiSelect
                                    className="w-full"
                                    autoComplete="none"
                                    id="idlojas"
                                    value={item.idlojas}
                                    options={lojaLista}
                                    onChange={(e) => aoDigitar(e, 'idlojas')}
                                    optionLabel="valor"
                                    optionValue="id"
                                    required
                                    placeholder="Selecione uma ou mais lojas"
                                />
                            </div>
                        </div>
                        <div className="grid formgrid">
                            <div className="field col-12">
                                <div className="flex align-items-center">
                                    <Checkbox inputId="repetir_anualmente" name="repetir_anualmente" value="1" onChange={(e) => aoSelecionar(e, 'repetir_anualmente')} checked={item.repetir_anualmente === 1} />
                                    <label htmlFor="repetir_anualmente" className="ml-2">Repetir Anualmente</label>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Dialog>
        </Tabela>
    );
}

export default Feriado;
